import { Alert, AlertPropsVariantOverrides } from '@mui/material';
import { OverridableStringUnion } from '@mui/types';
import { AxiosError, AxiosResponse } from 'axios';
import FormattedMessage from 'features/i18n/FormattedMessage';

export class TranslatedError extends Error {
  constructor(translationKey: string) {
    super(translationKey);
    this.name = 'TranslatedError';
  }
}

const isError = (error: unknown): error is Error =>
  error instanceof Error || Object.prototype.toString.call(error) === '[object Error]';

export type AxiosErrorTypes = AxiosResponse | AxiosError | TranslatedError | Error | string | null;

type Props = {
  error: AxiosErrorTypes;
  variant?: OverridableStringUnion<'standard' | 'filled' | 'outlined', AlertPropsVariantOverrides>
};

export const AxiosErrorResponseHandler = ({ error, variant = 'standardFullWidth' }: Props) => {
  if (!error) {
    return null;
  }

  let plainMessage = String(error);
  if (isError(error)) {
    plainMessage = `Unknown error - ${error}`;
  }
  let translatedMessage: string | null = null;

  if (typeof error === 'object') {
    if ('name' in error && error.name == 'TranslatedError') {
      translatedMessage = error.message
    } else {
      if ('response' in error && error.response) {
        error = error.response;
      }
      if ('data' in error) {
        if ('translationKey' in error.data && error.data.translationKey) {
          translatedMessage = error.data.translationKey;
        } else if ('error' in error.data && error.data.error) {
          plainMessage = error.data.error;
        }
      }
    }
  }

  let message: string | JSX.Element = plainMessage;
  if (translatedMessage) {
    message = <FormattedMessage id={translatedMessage} />;
  }

  return <Alert severity="error" variant={variant}>{message}</Alert>;
};
